module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAABaklEQVQ4jZWUvUsDQRDFf/lAIUaIiI1WIvoPWNgJgXRBEDSFXQQrsQhprMTGXpv0go1YpBOLFIJRURFBsBfENhJBbYw+2TgLR0hylwd77L7beTM7PAZJfpUUHaeBOGLuA8wCj8ARcEZ/TAIVYB04bN+UFJdUl/QkaTiYoc+qSGpKmvKVlIB9oADch1ThkQbOgTsg70Q+gVTE4G7IJk2gbMqDYBS4ADJJC3oGXEWbQCyCUA248odk4McEsAgkIoi89BK5BuYHeE7Gb+IRLs8BVeAdaAInwIztnVfqYSLOhLfW/KIFjQE3wLSZrYHZeLmHsapm8ViAS0iqSTr2XJjIl6RcF35J0ps/hz1nCPjowrv+jERt7AOw2oUvWK/+EfKcvKSWpLKklKS0pG1Jv5K2gqPAzYId4LIj2495Zw04AMaNbxifA1bao8Ma1AtZy+ZGxIItPy52JX1LKrpKXIOc5TvRAl5DerYB7P0BGiiPtbttyQIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/jxcgl.png
// module id = 3HjC
// module chunks = 1